import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6fc58c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "官网链接")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "ceci-info"
}
const _hoisted_4 = { class: "link-info" }

import { ref } from 'vue'
import DownFileDialog from '@/components/common/DownFileDialog.vue'
import VideoPlayer from '@/components/resource/VideoPlayer.vue'
import { Link } from '@element-plus/icons-vue'

// Define props with appropriate types

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  props: {
    data: {}
  },
  setup(__props: any) {



const dialogFormVisible = ref(false)
const currentUrl = ref('')
const dialogTitle = ref('')

const openOriginal = (url: string) => {
  const fileExtension = url.split('.').pop()?.toLowerCase()

  if (!fileExtension) {
    console.error('无法解析文件扩展名')
    return
  }

  if (url.includes('.exp.bcevod.com/')) {
    currentUrl.value = url
    dialogTitle.value = '资源下载受限，请添加 referrer: https://jpk.eduyun.cn/'
    dialogFormVisible.value = true
    return
  }

  if (fileExtension === 'm3u8') {
    currentUrl.value = url
    dialogTitle.value = 'M3U8 文件不能直接下载，请使用支持 M3U8 的播放器观看，或者下载到本地后再观看。'
    dialogFormVisible.value = true
    return
  }

  window.open(url, '_blank', 'noopener,noreferrer')
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DownFileDialog, {
      modelValue: dialogFormVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogFormVisible).value = $event)),
      title: dialogTitle.value,
      url: currentUrl.value
    }, null, 8, ["modelValue", "title", "url"]),
    _createVNode(_component_el_card, { shadow: "always" }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        (_ctx.data.length==0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_empty, {
                "image-size": 80,
                description: "暂无数据"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (value, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "flex-container"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_tag, { size: "large" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(key), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_input, {
                          modelValue: value[0],
                          "onUpdate:modelValue": ($event: any) => ((value[0]) = $event),
                          disabled: "",
                          "suffix-icon": _unref(Link),
                          size: "small"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix-icon"]),
                        _createVNode(_component_el_button, {
                          dark: "",
                          type: "primary",
                          onClick: ($event: any) => (openOriginal(value[0]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("打开")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(VideoPlayer, {
                          url: value[0]
                        }, null, 8, ["url"])
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})